//繁體中文
export default {

  // logo區域
  logoArea_text_welcome: "歡迎您",
  logoArea_text_myBalance: "餘額:",
  logoArea_btn_register: "註冊",
  logoArea_btn_login: "登入",
  logoArea_btn_recharge: "儲值",
  logoArea_btn_logout: "註銷",

  // 右上方標題區
  headerArea_btn_exitChat_title: "關閉聊天",
  headerArea_btn_history_title: "打開歷史聊天",
  headerArea_btn_save_title: "保存聊天",

  // 聊天區域
  charArea_item_notSupportAudio: "您的瀏覽器不支援音訊播放",
  charArea_item_historyFileExpire: "歷史生成的文件已過期",

  // 文件上傳區域
  uploadArea_btn_uploadFile_defaultText: "上傳文件",

  // 命令輸入區域
  inputPanelArea_default_cmdRunFail: "執行失敗",
  inputPanelArea_cmdConfigNotFound: "命令不存在",
  inputPanelArea_cmdNotFound: "命令未找到！",
  inputPanelArea_cmdNotNnderstand: "系統無法理解您的意圖，請重試！",
  inputPanelArea_btn_text_send: "發送",
  inputPanelArea_btn_text_sending: "發送中",

  pleaseLoginAfterUse: "請先登入後再呼叫服務",
  registerSuccess: "用戶註冊成功",
  serviceFail: "介面請求失敗",
  loginExpired: "登入過期，請重新登入。",
  insufficientBalance: "餘額不足，請儲值。",

  // 確認框
  confirmed_exitChat_title: "您確定要關閉聊天嗎？",
  confirmed_exitChat_content: "聊天正在進行中，強行關閉將導致聊天記錄丟失。建議先保存後關閉。",
  confirm_overlapChat_title: "歷史聊天記錄[{{saveName}}]已經存在，確定覆蓋嗎？",
  confirm_overlapChat_content: "聊天正在進行中，強行關閉會導致聊天記錄丟失，建議先保存後關閉。",

  // 氣泡彈窗
  pop_input_saveName_placeholder: "請輸入保存名稱，按<Enter>鍵保存",

  // 普通彈窗
  modal_title_userLogin: "用戶登入",
  modal_title_userRegister: "用戶註冊",
  modal_title_newUser: "歡迎光臨！",
  modal_title_newRechange: "會員儲值",
  nodal_content_newUser: "Dalipen是一家致力於推進多媒體技術的公司，在這裡，您可以選擇您想要的功能。為了幫助您入門，我們為您準備了 100 個代幣。",
  modal_btn_newUser: "讓我們開始吧！",
  modal_btn_okText: "確定",
  modal_btn_cancelText: "取消",
  modal_btn_loginText: "登入",
  modal_btn_rechange: "儲值",
  modal_btn_getEmailCodeText: "獲取郵箱驗證碼",
  modal_btn_registerText: "註冊",
  modal_input_rechangeMoney_placeholder: "請輸入儲值金額",
  modal_form_email_label: "郵箱",
  modal_form_email_errorMsg: "請輸入郵箱！",
  modal_form_password_label: "密碼",
  modal_form_password_errorMsg: "請輸入密碼！",
  modal_form_code_label: "驗證Code",
  modal_form_code_errorMsg: "請輸入您的驗證碼！",

  // 消息提示
  message_save_success: "保存成功",
  message_warn_isChatting: "正在聊天，建議先保存",
  message_error_rechange1: "請輸入儲值金額",
  message_error_rechange2: "請輸入正確金額，最小為1",

  // 支付結果頁面
  pay_result_success: "支付成功",
  pay_result_success_message: "感謝您的購買！",
  pay_result_fail: "支付失敗",

  // 菜單區域
  menu_text: "文字",
  menu_text_10001: "SellMeThisPen",
  menu_text_10002: "Tiktok短影片文案",
  menu_text_10003: "翻譯",
  menu_text_10004: "圖像反推",
  menu_text_10005: "聊天",
  menu_video: "影片",
  menu_video_20001: "模板",
  menu_video_20002: "自訂模板",
  menu_video_20003: "數位人",
  menu_video_20004: "風格遷移",
  menu_video_20005: "文生影片",
  menu_audio: "音訊",
  menu_audio_30001: "TTS",
  menu_audio_30002: "語音轉文字",
  menu_audio_30003: "人聲分離",
  menu_image: "圖片",
  menu_image_40001: "文生圖",
  menu_image_40002: "文生圖(flux)",
  menu_image_40003: "文生圖(SD3)",

  //命令設置文件
  command_clean_desc: "清除當前對話框",
  command_content_desc: "欄位型命令，用於配置輸出文字內容",
  command_mp3Upload_desc: "上傳音訊MP3文件",
  command_mp3Upload_okMsg: "音訊文件已上傳成功。\n{{audio:value}}",
  command_mp3Upload_errorMsg: "上傳音訊文件失敗，請重試",
  command_mp3Upload_ext_buttonText: "上傳音訊MP3文件",
  command_imageUpload_desc: "上傳圖片文件",
  command_imageUpload_okMsg: "圖片文件已上傳成功。\n{{image:value}}",
  command_imageUpload_errorMsg: "上傳圖片文件失敗，請重試",
  command_imageUpload_ext_buttonText: "上傳圖片文件",
  command_pitch_desc: "欄位類型命令，用於配置輸出音調（預設值:0）",
  command_pitch_okMsg: "指定的語調:{{value}}",
  command_pitch_errorMsg: "值類型或格式不正確，必須為數字",
  command_empty_desc: "",
  command_empty_okMsg: "",
  command_empty_errorMsg: "",
  command_separator_desc: "分隔符語音（需先執行/separator_upload命令）",
  command_separator_okMsg: "啟動成功",
  command_separator_errorMsg: "啟動失敗，請重試",
  command_speechToText_desc: "上傳語音文件並自動轉為文字",
  command_speechToText_okMsg: "",
  command_speechToText_errorMsg: "",
  command_upload_a_video_ext_buttonText: "上傳影片|圖片文件",
  command_upload_a_video_desc: "上傳一個影片|圖片",
  command_upload_a_video_okMsg: "",
  command_upload_a_video_errorMsg: "",
  command_upload_a_audio_ext_buttonText: "上傳音訊文件",
  command_upload_a_audio_desc: "上傳一個音訊",
  command_upload_a_audio_okMsg: "",
  command_upload_a_audio_errorMsg: "",
  command_set_prompt_desc: "輸入想让生成影片的prompt (中文)",
  command_set_prompt_okMsg: "",
  command_set_prompt_errorMsg: "",
  command_digital_human_desc: "生成",
  command_digital_human_okMsg: "開始生成",
  command_digital_human_errorMsg: "失敗",
  command_txt_2_video_desc: "生成",
  command_txt_2_video_okMsg: "開始生成",
  command_txt_2_video_errorMsg: "失敗",
  command_speaker_desc: "欄位型命令，彈出下拉框選擇音調",
  command_speaker_okMsg: "指定音色:",
  command_choose_style_okMsg: "指定風格:",
  command_language_okMsg: "指定語言:",
  command_speed_desc: "欄位型命令，用於配置速度（預設:1）",
  command_speed_okMsg: "指定速度:{{value}}",
  command_speed_errorMsg: "值類型或格式不正確，必須為數字",
  command_tts_desc: "生成語音（需要先執行/speaker和/content命令）",
  command_tts_okMsg: "AI音訊輸出:\n{{audioBlob}}",
  command_tts_errorMsg: "AI音訊輸出失敗",
  command_volume_desc: "欄位類型命令，用於配置輸出音量（預設值:1）",
  command_volume_okMsg: "指定的音量:{{value}}",
  command_volume_errorMsg: "值類型或格式不正確，必須為數字！",

  command_separatorUpload_desc: "上傳MP3文件",
  command_separatorUpload_okMsg: "文件上傳成功\n{{audio:value}}",
  command_separatorUpload_errorMsg: "上傳資源文件失敗，請重試",
  command_separatorUpload_ext_buttonText: "上傳 MP3 資源文件",

  // 頁面連結
  page_link_aboutUs: "關於我們",
  page_link_privacyPolicy: "隱私政策",

}